import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import './index.css';
import { AppContainer } from './AppContainer';

// Clear persisted theme to ensure light mode on every application load
localStorage.removeItem('theme');

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root container missing in index.html');
const root = createRoot(rootElement);
root.render(
  <StrictMode>
    <AppContainer />
  </StrictMode>,
);
